module.exports = __webpack_public_path__ + "static/img/1-2.6eb91b34.jpg";